import { css, StyleSheet } from 'aphrodite/no-important'
import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { FormInput } from '../LEGACY/elemental'
import { Glyph } from '../LEGACY/Glyph'

function ListHeaderSearch({
  focusInput,
  handleChange,
  handleClear,
  handleKeyup,
  inputStyle,
  placeholder,
  multiline,
  value,
  ...props
}) {
  return (
    <div {...props} className={css(classes.wrapper)}>
      <FormInput
        data-search-input-field
        onChange={handleChange}
        onKeyUp={handleKeyup}
        placeholder={placeholder || 'Search'}
        style={inputStyle}
        value={value}
        multiline={multiline}
      />
      <button
        className={css(classes.icon, !!value.length && classes.iconWhenClear)}
        data-search-input-field-clear-icon
        disabled={!value.length}
        onClick={value.length ? handleClear : null}
        title="Clear search query"
        type="button"
      >
        <Glyph name={value.length ? 'x' : 'search'} />
      </button>
    </div>
  )
}

ListHeaderSearch.propTypes = {
  focusInput: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  handleClear: PropTypes.func.isRequired,
  handleKeyup: PropTypes.func,
  value: PropTypes.string,
}

const clearHoverAndFocusStyles = {
  color: colors.red,
  outline: 0,
  textDecoration: 'none',
}

const classes = StyleSheet.create({
  wrapper: {
    position: 'relative',
  },
  icon: {
    background: 'none',
    border: 'none',
    color: colors.darkgrey,
    height: '100%',
    position: 'absolute',
    right: 0,
    textAlign: 'center',
    top: 0,
    width: '2.2em',
    zIndex: 2, // above the form field on focus
  },
  iconWhenClear: {
    ':hover': clearHoverAndFocusStyles,
    ':focus': clearHoverAndFocusStyles,
    ':active': {
      color: colors.red,
    },
    transition: 'color .2s ease',
  },
})

export default ListHeaderSearch
